import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SynopticsService } from '../../../services/synoptics.service';
import { Synoptic } from '../../../model/synoptics/synoptic';

@Component({
  selector: 'app-synoptic-details',
  templateUrl: './synoptic-details.component.html',
  styleUrls: ['./synoptic-details.component.scss']
})
export class SynopticDetailsComponent implements OnInit {

  public synoptic: Synoptic;

  constructor(
    private route: ActivatedRoute,
    private synopticsService: SynopticsService,
  ) { }

  ngOnInit(): void {
    this.route.url.subscribe(urlSegment => this.loadSynoptic(urlSegment[0].path));
  }

  private loadSynoptic(uuid: string): void {
    this.synopticsService.getSynoptic(uuid).subscribe(response => {
      this.synoptic = response.synoptic;
    });
  }

}
